import { h, toChildArray } from 'preact';
import { isValidElement } from 'preact/compat';
import { useStyles } from '../../../../common/hooks';

export function CockpitBubble({ children, style = {}, hidden = false, direction = 'row' }) {
  const mainFixedStyle = useStyles()({
    default: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: direction,
      borderRadius: '39.47px',
      gap: '16px',
      height: 'max-content',
      width: 'max-content'
    },
    'small+extraSmall': {
      padding: direction === 'row' ? '4px 8px' : '8px 4px'
    },
    medium: {
      padding: direction === 'row' ? '4px 10px' : '10px 4px'
    },
    'large+extraLarge': {
      padding: direction === 'row' ? '4px 12px' : '12px 4px'
    }
  });
  // Convert to array and filter out falsy values AND components with hidden={true}
  const visibleChildren = toChildArray(children).filter((child) => {
    if (!child || (isValidElement(child) && !!child.props?.hidden)) {
      return false;
    }
    return true;
  });

  return (!hidden && visibleChildren.length && (
    <div
      role="presentation"
      onClick={(e) => e.stopPropagation()}
      className="ftv-magneto--glass ftv-magneto--glass--bordered"
      style={{ ...style, ...mainFixedStyle }}
    >
      {visibleChildren.map((child) => child)}
    </div>
  )) || null;
}
